import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { useChatControl } from 'libs/rendering/hooks';

import { ViewerControl } from 'libs/rendering/gltf/viewerControl';
import { ViewerControlProvider } from 'libs/rendering/gltf/hooks';
import { getViewer } from 'libs/rendering/utils';

export const PreviewViewer = observer(props => {
  const { formatObj, file, name, ...restProps } = props;
  const chatControl = useChatControl();
  const Viewer = getViewer(formatObj);
  if (!Viewer) {
    return null;
  }

  return (
    <ViewerControlProvider value={null}>
      <Viewer
        file={file}
        mode={formatObj.mode}
        isPreview={true}
        chatControl={chatControl}
        {...restProps}
      />
    </ViewerControlProvider>
  );
});

PreviewViewer.propTypes = {
  formatObj: PropTypes.object,
  file: PropTypes.object,
  name: PropTypes.string,
};

export const PreviewGltf = observer(props => {
  const { formatObj, file, name, ...restProps } = props;
  const chatControl = useChatControl();
  const [viewerControl] = useState(() => new ViewerControl(null, true));
  const Viewer = getViewer(formatObj);
  if (!Viewer) {
    return null;
  }

  // - make it global so we can use it
  // when generating previews
  // - this should only be neccessary here cause this is the
  // component that gets used when looking at a /viewer/<id>
  // endpoint
  window._viewerControl = viewerControl;

  return (
    <ViewerControlProvider value={viewerControl}>
      <Viewer
        file={file}
        mode={formatObj.mode}
        isPreview={true}
        chatControl={chatControl}
        {...restProps}
      />
    </ViewerControlProvider>
  );
});

PreviewGltf.propTypes = {
  formatObj: PropTypes.object,
  file: PropTypes.object,
  name: PropTypes.string,
};
